import { put, all, takeLatest, select } from "redux-saga/effects";
import * as actionTypes from "./actionTypes";
import API from "../../commonUtils/API.js";
import { toast } from "react-toastify";
import { handleApiError } from "../../commonUtils/Functions";

function* getChannelPartnersSaga({ params }) {
    const { currentPage, perPage } = params;

    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const filters = yield select((state) => state.ChannelPartners.filters);

        let queryString = `currentPage=${currentPage}&perPage=${perPage}`;
        if(filters.keyword) queryString = queryString.concat(`&keyword=${encodeURIComponent(filters.keyword)}`);

        const { data } = yield API.get(`/channel-partners?${queryString}`);

        if (data.success) {
            yield put({ type: actionTypes.GET_CHANNEL_PARTNERS_SUCCESS, payload: data.data });
        } else {
            toast.error("Oops! Something went unexpectedly wrong.");
            yield put({ type: actionTypes.GET_CHANNEL_PARTNERS_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Oops! Something went unexpectedly wrong.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.GET_CHANNEL_PARTNERS_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

function* createChannelPartnerSaga({ payload }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });
        const { formData } = payload;
        const { data } = yield API.post("/channel-partners", formData);
        if (data.success) {
            yield put({ type: actionTypes.CREATE_CHANNEL_PARTNER_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_CHANNEL_PARTNERS, params: {} });
        } else {
            toast.error(data?.message || "Could not save channelPartner.");
            yield put({ type: actionTypes.CREATE_CHANNEL_PARTNER_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Could not save channelPartner.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.CREATE_CHANNEL_PARTNER_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

function* updateChannelPartnerSaga({ payload }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });
        const { id, formData } = payload;
        const { data } = yield API.put(`/channel-partners/${id}`, formData);
        if (data.success) {
            const { pagination } = yield select((state) => state.ChannelPartners.ChannelPartnersList);
            const params = { currentPage: pagination.currentPage, perPage: pagination.perPage };
            yield put({ type: actionTypes.UPDATE_CHANNEL_PARTNER_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_CHANNEL_PARTNERS, params });
        } else {
            toast.error(data?.message || "Could not save updated channelPartner data.");
            yield put({ type: actionTypes.UPDATE_CHANNEL_PARTNER_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Could not save updated channelPartner data.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.UPDATE_CHANNEL_PARTNER_FAILURE, payload: data || { message: "Internal server error" } });
    }
}

function* updateChannelPartnerStatusSaga({ Id }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const { data } = yield API.patch(`/channel-partners/${Id}/status`);

        if (data.success) {
            const { pagination } = yield select((state) => state.ChannelPartners.ChannelPartnersList);
            const params = { currentPage: pagination.currentPage, perPage: pagination.perPage };
            yield put({ type: actionTypes.UPDATE_CHANNEL_PARTNER_STATUS_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_CHANNEL_PARTNERS, params });
        } else {
            toast.error(data?.message || "Could not update channelPartner status.");
            yield put({ type: actionTypes.UPDATE_CHANNEL_PARTNER_STATUS_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Could not update channelPartner status.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.CREATE_CHANNEL_PARTNER_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

function* deleteChannelPartnerSaga({ Id }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const { data } = yield API.delete(`/channel-partners/${Id}`);

        if (data.success) {
            const { pagination } = yield select((state) => state.ChannelPartners.ChannelPartnersList);
            const params = { currentPage: pagination.currentPage, perPage: pagination.perPage };
            yield put({ type: actionTypes.DELETE_CHANNEL_PARTNER_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_CHANNEL_PARTNERS, params });
        } else {
            toast.error(data?.message ||"Could not delete channel partner.");
            yield put({ type: actionTypes.DELETE_CHANNEL_PARTNER_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Could not delete channelPartner.");
        const data = error?.response?.data;
        toast.error(data?.message ||"Could not delete channel partner.");
        yield put({ type: actionTypes.CREATE_CHANNEL_PARTNER_FAILURE, payload: data || { message: "Internal server error" } });
    }
};


function* ChannelPartnersSaga() {
  yield all([
    takeLatest(actionTypes.GET_CHANNEL_PARTNERS, getChannelPartnersSaga),
    takeLatest(actionTypes.CREATE_CHANNEL_PARTNER, createChannelPartnerSaga),
    takeLatest(actionTypes.UPDATE_CHANNEL_PARTNER, updateChannelPartnerSaga),
    takeLatest(actionTypes.UPDATE_CHANNEL_PARTNER_STATUS, updateChannelPartnerStatusSaga),
    takeLatest(actionTypes.DELETE_CHANNEL_PARTNER, deleteChannelPartnerSaga),
  ]);
}

export default ChannelPartnersSaga;
